<template>
  <v-row class="mt-0">
    <v-col cols="12">
      <v-tabs
        v-model="tab"
        grow
        icons-and-text
        slider-size="3"
        background-color="teal lighten-2"
        active-class="indigo lighten-1"
        slider-color="indigo darken-2"
        center-active
        show-arrows
      >
        <v-tab v-for="(hol, i) in holerites" :key="i" class="white--text">
          {{ hol.desc_mes.substring(0, 3).toUpperCase() }}/{{ hol.ano }}
          <p class="body-2">{{ hol.tipo_holerite }}</p>
        </v-tab>
        <v-tabs-items v-model="tab" mandatory>
          <v-tab-item v-for="hol in holerites" :key="hol.id">
            <card-holerite :holerite="hol" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-col>
  </v-row>
</template>

<script>
import CardHolerite from "./CardHolerite.vue";
export default {
  components: { CardHolerite },
  data: () => ({
    tab: 0,
    holeriteSelec: 0,
  }),
  props: {
    holerites: Array,
  },
};
</script>

<style>
</style>